/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Faq_TitleInputs */

const he_seo_faq_title = /** @type {(inputs: Seo_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שאלות נפוצות - Pricedrop | מעקב מחירים KSP`)
};

const en_seo_faq_title = /** @type {(inputs: Seo_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ - Pricedrop | KSP Price Tracking`)
};

/**
* | output |
* | --- |
* | "FAQ - Pricedrop \| KSP Price Tracking" |
*
* @param {Seo_Faq_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_faq_title = /** @type {((inputs?: Seo_Faq_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Faq_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_faq_title(inputs)
	return en_seo_faq_title(inputs)
});